/*
   This is meant for the top of the page -- which step are we on?
      1 -- select them
      2 -- buid a journey
      3 -- print your guide
      4 -- explore the museum
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../css/JourneyNavProgress.css'
import { setJourneyNavStep, resetToHome, receivePDF } from '../../actions/journey-actions'
import { 
  getCurrentNavStep, 
  getSelectedJourney, 
  personalizedName } from '../../selectors/journeyState-selectors'
import JourneyNavProgressPanel from './JourneyNavProgressPanel'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';

const JourneyNavProgress = props => (
  <span>
   <Hammer onTap={() => props.resetToHome(props.galleryId)} options={tapOptions} >
      <JourneyNavProgressPanel label={[1, props.getSelectedJourney ? props.getSelectedJourney.title.toUpperCase() : 'n/a', 'SELECT', 'A THEME', 'Begin your journey by selecting a theme']} galleryId={props.galleryId} />
   </Hammer>
   <JourneyNavProgressPanel label={[2, 'SELECTIONS COMPLETE!', 'BUILD', 'A JOURNEY', 'Add works of art to your journey!']} galleryId={props.galleryId} />
   
   <Hammer onTap={() => {if (props.currentNavStep == 4) { props.receivePDF(props.galleryId, null); props.setJourneyNavStep(props.galleryId, 3)}}} options={tapOptions} >
      <JourneyNavProgressPanel label={[3, `GREAT WORK, ${props.personalizedName.toUpperCase()}!`, 'PRINT', 'YOUR MYGUIDE', 'Personalize your Journey with your name']} galleryId={props.galleryId} />
   </Hammer>
   <JourneyNavProgressPanel label={[4, 'SENT TO PRINTER!', 'EXPLORE', 'THE MUSEUM', 'Get started exploring the Museum!']} galleryId={props.galleryId} />
  </span>
)

const mapStateToProps = (state, ownProps) => ({
  currentNavStep: getCurrentNavStep(state, ownProps),
  getSelectedJourney: getSelectedJourney(state, ownProps),
  personalizedName: personalizedName(state, ownProps),
  ...ownProps
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setJourneyNavStep,
  resetToHome,
  receivePDF,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyNavProgress)


// WEBPACK FOOTER //
// ./src/components/JourneyNavProgress/JourneyNavProgress.js